var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "44px",
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2021/FormIcon - Phone") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "2021/FormIcon---Phone",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Phone",
    transform: "translate(14.000000, 14.000000)",
    stroke: "#221F1F",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.93,12.93 C13.3,13.3 14.09,17 8.5,17 C3.81,17 0,13.19 0,8.5 C0,3.81 3.81,0 8.5,0 C13.19,0 17,3.81 17,8.5 C17,10.28 16.45,11.94 15.51,13.3 M7.19,6.3 C7.66,5.83 7.7,5.11 7.27,4.69 L6.13,3.55 C5.71,3.12 4.99,3.16 4.52,3.63 L3.82,4.33 C3.21,4.93 3.08,5.84 3.49,6.49 C5.26,9.3 7.7,11.74 10.51,13.51 C11.16,13.92 12.07,13.79 12.67,13.18 L13.37,12.48 C13.84,12.01 13.88,11.29 13.46,10.87 L12.32,9.73 C11.9,9.31 11.18,9.35 10.71,9.81 L10.29,10.23 C9,9.22 7.78,8 6.77,6.73 L7.19,6.3 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.0ac2e487.svg";
export { ForwardRef as ReactComponent };